// src/components/AppHeader.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import profileIcon from "../assets/icons/profile.svg";
import { useWalletConnect } from "../WalletConnectContext";
import WalletConnectControl from "./WalletConnectControl";

function shortAccount(accountId) {
  const value = String(accountId || "").trim();
  if (value.length <= 14) return value;
  return `${value.slice(0, 6)}…${value.slice(-4)}`;
}

export default function AppHeader() {
  const location = useLocation();
  const { accountId } = useWalletConnect() || {};
  const path = String(location?.pathname || "/").trim() || "/";
  const showProfileIcon = path === "/" || path === "/home";
  if (!showProfileIcon) return null;

  return (
    <header
      className="app-header"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "10px 12px 0 12px",
        position: "relative",
        zIndex: 25,
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <div
        className="app-header__actions"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 8,
          minWidth: 0,
          maxWidth: "100%",
        }}
      >
        {accountId ? (
          <div
            className="staking-wallet-chip app-header-wallet-chip"
            title={accountId}
            aria-label={accountId}
          >
            <span>{shortAccount(accountId)}</span>
            <span className="staking-wallet-chip__dot" />
          </div>
        ) : (
          <WalletConnectControl className="app-header-wallet-chip" />
        )}

        <Link
          to="/user"
          aria-label="User profile"
          title="Profile"
          style={{
            display: "flex",
            alignItems: "center",
            flex: "0 0 auto",
          }}
        >
          <img
            src={profileIcon}
            alt="Profile"
            width={32}
            height={32}
            style={{
              borderRadius: "50%",
              objectFit: "cover",
              display: "block",
              cursor: "pointer",
            }}
          />
        </Link>
      </div>
    </header>
  );
}
